import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { paymentsAPI } from '@/lib/api';
import { CheckCircle2, Loader2 } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_xalawnsplus/artifacts/gh7eo36y_a0d14065-cb1f-449b-a4f6-38140797df8a.png";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const checkStatus = async () => {
      if (!sessionId) {
        setLoading(false);
        return;
      }

      try {
        const response = await paymentsAPI.getStatus(sessionId);
        setPaymentData(response.data);
      } catch (error) {
        console.error('Failed to check payment status:', error);
      } finally {
        setLoading(false);
      }
    };

    // Poll for status
    checkStatus();
    const interval = setInterval(checkStatus, 2000);
    
    // Stop polling after 10 seconds
    setTimeout(() => clearInterval(interval), 10000);
    
    return () => clearInterval(interval);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 text-center">
        {loading ? (
          <>
            <Loader2 className="w-16 h-16 text-lime-500 mx-auto mb-6 animate-spin" />
            <h1 className="font-heading text-2xl font-bold text-white uppercase mb-4">
              Processing Payment...
            </h1>
            <p className="text-gray-400">Please wait while we confirm your payment.</p>
          </>
        ) : (
          <>
            <div className="w-20 h-20 rounded-full bg-lime-500 flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-10 h-10 text-black" />
            </div>
            <h1 className="font-heading text-3xl font-bold text-white uppercase mb-4">
              Payment Successful!
            </h1>
            <p className="text-gray-400 mb-4">
              Thank you for your payment. A receipt has been sent to your email.
            </p>
            
            {paymentData && (
              <div className="card-dark p-6 mb-8 text-left">
                <h3 className="font-heading text-lg font-bold text-white uppercase mb-4">Payment Details</h3>
                <div className="space-y-2 text-gray-400">
                  <div className="flex justify-between">
                    <span>Amount:</span>
                    <span className="text-lime-500 font-bold">${paymentData.amount?.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Status:</span>
                    <span className="text-lime-500">{paymentData.payment_status}</span>
                  </div>
                </div>
              </div>
            )}

            <div className="flex flex-col gap-3">
              <Link to="/portal">
                <Button className="btn-primary w-full" data-testid="back-portal-btn">
                  Back to Portal
                </Button>
              </Link>
              <Link to="/">
                <Button variant="outline" className="w-full border-[#404040] text-white hover:bg-[#262626]">
                  Back to Home
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
